module.exports = __webpack_public_path__ + "img/img_nav_bet.68d80e6f.svg";